document.querySelectorAll(".accordion__button").forEach((a) => {
    a.addEventListener("click", function () {
        console.log(a);
        let isExpanded = this.getAttribute("aria-expanded") === "true";
        a.setAttribute("aria-expanded", !isExpanded);

        var panel = a.parentElement.nextElementSibling;
        console.log(panel);
        panel.setAttribute("aria-hidden", isExpanded);

        if (panel.style.display === "block") {
            panel.style.display = "none";
        } else {
            panel.style.display = "block";
        }
        
        panel.querySelectorAll(".icon").forEach((iconV) => {
            iconV.toggleClass('icon--active');
        });
    });
  })
  